import {LEGACY_TO_NEW_ROUTE_MAP} from './legacy-to-new-route-map'
import {normalizeNavPath} from './normalize-nav-path'

const NEW_TO_LEGACY = Object.fromEntries(Object.entries(LEGACY_TO_NEW_ROUTE_MAP).map(([legacy, app]) => [app, legacy]))

export function resolveLegacyPortalPath(newPortalPath: string) {
  const normalized = normalizeNavPath(newPortalPath)
  return NEW_TO_LEGACY[normalized] ?? normalized
}
